var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatainline = function SvgDatainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#576CDB",
    rx: 5.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.501 27.75a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5M22.5 11.25a2.812 2.812 0 1 0 0-5.625 2.812 2.812 0 0 0 0 5.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "M22.5 8.438V15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 33.75a2.812 2.812 0 1 0 0 5.625 2.812 2.812 0 0 0 0-5.625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "M22.5 36.563V30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.75 22.5a2.812 2.812 0 1 0 5.625 0 2.812 2.812 0 0 0-5.625 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "M36.563 22.5H30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.25 22.5a2.812 2.812 0 1 0-5.625 0 2.812 2.812 0 0 0 5.625 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "M8.438 22.5H15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.452 14.545a2.813 2.813 0 1 0 3.978-3.978 2.813 2.813 0 0 0-3.978 3.978"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "m32.44 12.555-4.64 4.64"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.544 30.455a2.812 2.812 0 1 0-3.978 3.977 2.812 2.812 0 0 0 3.978-3.977"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "m12.555 32.444 4.64-4.64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.456 30.456a2.812 2.812 0 1 0 3.977 3.977 2.812 2.812 0 0 0-3.977-3.977"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "m32.446 32.444-4.64-4.64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.544 14.546a2.812 2.812 0 1 0-3.977-3.978 2.812 2.812 0 0 0 3.977 3.978"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.05,
    d: "m12.554 12.557 4.64 4.64"
  })));
};
export default SvgDatainline;